import React from 'react';

const SelectInput = function({children,value,change,disabled,...props}) {
    return (
      <select value={value} onChange={change} className="select-input" disabled={disabled ? true : false}>
          {children}
      </select>
    );
}

export default SelectInput;
